import React from 'react'
import { FaUserFriends } from 'react-icons/fa'
import { Circle } from '@mui/icons-material'
import { MVPButton, MVPButtonProps } from '../../Buttons/MVPButton'
import { FriendsMenu } from './FriendsMenu'
import './FriendsButton.scss'

interface Props extends MVPButtonProps
{
	showFriendsIndicator: boolean,
	showFriendsRequetsIndicator: boolean
}
export const FriendsButton = ({ showFriendsIndicator, showFriendsRequetsIndicator, ...buttonProps } : Props) =>
{
	return (
		<div id='friends-button-container'>
			<MVPButton id='friends-button' className='clear' {...buttonProps}>
				<FaUserFriends />
				{(showFriendsIndicator || showFriendsRequetsIndicator) && <Circle className='indicator' color='error'/>}
			</MVPButton>
			<FriendsMenu showFriendsIndicator={showFriendsIndicator} showFriendsRequetsIndicator={showFriendsRequetsIndicator} />
		</div>
	)
}
